<template>
  <li :class="megaMenuFullWidth ? [] : ['wf-relative']">
    <button :class="classes" :style="styles" @click.prevent="showMenu" class="focus:wf-outline-none">
      <span v-text="navLink.text"></span> <i v-show="navLink.children.length" class="fas fa-chevron-down wf-text-xs wf-mt-1 wf-ml-1"></i>
    </button>
    <HeaderNavLinkMenu
      v-if="menu && ! hasGrandchildren"
      :children="navLink.children"
      :classes="subMenuClasses"
      :containerClasses="subMenuContainerClasses"
      :styles="subMenuStyles"
      :containerStyles="subMenuContainerStyles"
    />
    <HeaderNavLinkMegaMenu
      v-if="menu && hasGrandchildren"
      :children="navLink.children"
      :classes="megaMenuClasses"
      :styles="megaMenuStyles"
      :fullWidth="megaMenuFullWidth"
      :containerClasses="megaMenuContainerClasses"
      :containerStyles="megaMenuContainerStyles"
      :titleClasses="megaMenuTitleClasses"
      :titleStyles="megaMenuTitleStyles"
    />
  </li>
</template>

<script>
  import HeaderNavLinkMenu from './HeaderNavLinkMenu'
  import HeaderNavLinkMegaMenu from './HeaderNavLinkMegaMenu'
  export default {
    props: {
      megaMenuFullWidth: {
        type: Boolean,
        required: false,
        default: false
      },
      megaMenuClasses: {
        type: [String, Array],
        required: true
      },
      megaMenuStyles: {
        type: [String, Object],
        required: true
      },
      megaMenuTitleClasses: {
        type: [String, Array],
        required: true
      },
      megaMenuTitleStyles: {
        type: [String, Object],
        required: true
      },
      megaMenuContainerClasses: {
        type: [String, Array],
        required: true
      },
      megaMenuContainerStyles: {
        type: [String, Object],
        required: true
      },
      subMenuContainerClasses: {
        type: [String, Array],
        required: true
      },
      subMenuContainerStyles: {
        type: [String, Object],
        required: true
      },
      subMenuClasses: {
        type: [String, Array],
        required: true
      },
      subMenuStyles: {
        type: [String, Object],
        required: true
      },
      classes: {
        type: [String, Array],
        required: true
      },
      styles: {
        type: [String, Object],
        required: true
      },
      navLink: {
        type: Object,
        required: true
      }
    },
    components: {HeaderNavLinkMenu, HeaderNavLinkMegaMenu},
    data() {
      return {
        menu: false
      }
    },
    computed: {
      hasGrandchildren() {
        return this.navLink.children.some(child => child.children.length)
      }
    },
    methods: {
      showMenu() {
        if (! this.navLink.children.length) {
          return
        }
        this.menu = ! this.menu
      }
    }
  }
</script>